import React from 'react';
import { compose } from 'recompose';
import { withStoreDetail } from '../../Common/Providers/WithStoreDetail';
import { connectUserHeaderinfo } from '../../Auth/WithUserHeaderInfo';
import Plans from './Plans';
import PlanInfo from './PlanInfo';
import { HTMLTrans } from '../../Common/Translations';

const Subscription = (props) => {
  const {
    userHeaderInfo: { isSubscriber = false },
    globalShippingCreditEnabled
  } = props;

  const data = {
    heading: 'My Photobook Pass',
  };

  const shouldCallApi = window.location.pathname.includes('pass');

  return (
    <div className='dashboard-card'>
      <h3><HTMLTrans id="account.photobookpass_title">{data.heading}</HTMLTrans></h3>
      <hr />
      {!isSubscriber ? (
        <Plans shouldCallApi={shouldCallApi}/>
      ) : (
        <PlanInfo shouldCallApi={shouldCallApi} globalShippingCreditEnabled={globalShippingCreditEnabled} />
      )}
    </div>
  );
}

const enhance = compose(
  connectUserHeaderinfo,
  withStoreDetail,
);
export default enhance(Subscription);
export const undecorated = Subscription;



// WEBPACK FOOTER //
// ./src/Account/Subscription/Subscription.js